export default "__VITE_ASSET__Bk2n9vIh__"